document.addEventListener('DOMContentLoaded', () => {
    const $collapseColumn = document.querySelectorAll('.collapse-column');

    if ($collapseColumn) {
        $collapseColumn.forEach($column => {
            const $button = $column.nextElementSibling.querySelector('.collapse-button');

            $button.addEventListener('click', () => {
                $column.classList.toggle('is-active');
                $button.classList.toggle('is-active');
            });

            calcOverflow($column);

            window.addEventListener('resize', () => {
                calcOverflow($column);
            });
        });
    }
});


function calcOverflow($collapseColumn) {
    const $nextColumn = $collapseColumn.nextElementSibling;

    const originalClamp = $collapseColumn.style.webkitLineClamp;

    $collapseColumn.style.webkitLineClamp = 'unset';

    const fullHeight = $collapseColumn.scrollHeight;

    $collapseColumn.style.webkitLineClamp = originalClamp || '1';

    const visibleHeight = $collapseColumn.offsetHeight;

    const tolerance = 4;
    if (fullHeight - visibleHeight > tolerance) {
        $nextColumn.classList.remove('is-hidden');
    } else {
        $nextColumn.classList.add('is-hidden');
    }

}


